import { useTranslation } from 'react-i18next';
import { TabsList, TabsTrigger } from '@/shared/components/ui/tabs';

/**
 * Both tabs share this: full height, centred, no pill background. The active one takes the primary
 * colour and a 2px underline flush with the header divider; the inactive one stays muted but at full
 * contrast.
 */
const TAB_CLASS = [
  'relative h-11 w-full rounded-none border-0 bg-transparent p-0 text-sm shadow-none',
  'data-[state=inactive]:bg-transparent dark:data-[state=inactive]:bg-transparent',
  'data-[state=active]:bg-transparent dark:data-[state=active]:bg-transparent',
  'data-[state=active]:shadow-none',
  'text-muted-foreground data-[state=active]:font-medium data-[state=active]:text-primary',
  'after:absolute after:inset-x-0 after:-bottom-px after:h-0.5 after:bg-transparent',
  'data-[state=active]:after:bg-primary',
].join(' ');

/**
 * The blank/AI tab header. Two equal halves with centred labels and an underline on the
 * active one, as the design draws it. The underline is a pseudo-element rather than a
 * border so it sits on the header's divider instead of stacking a second line beneath it.
 */
export function AiQuickCreateTabsHeader() {
  const { t } = useTranslation('ai');

  return (
    <TabsList className="h-11 w-full grid-cols-2 gap-0 rounded-none border-b bg-transparent p-0 [display:grid]">
      <TabsTrigger value="blank" className={TAB_CLASS} data-testid="ai-quick-create-tab-blank">
        {t('quickCreate.blankTab')}
      </TabsTrigger>
      <TabsTrigger value="ai" data-testid="ai-quick-create-tab-ai" className={TAB_CLASS}>
        {t('quickCreate.aiTab')}
      </TabsTrigger>
    </TabsList>
  );
}
